export default "__VITE_ASSET__DkmKfCRc__"